module.exports = __webpack_public_path__ + "43bac38ef62f07e87dfd9cfec8e9494e.png";